module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12 text-center\">\r\n        <p>\r\n            Página en construcción, ¡regresa pronto!\r\n          </p>\r\n          \r\n          <a routerLink=\"/\">Regresar al inicio</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main